import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useAlarmRawEventsQuery(options) {
  var queryApi = useDeviceQueryApi();
  return queryApi.useAlarmRawEventsQuery(options);
}